import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="nav-buttons"
export default class extends Controller {
  static targets = ["overlay"];

  hideOverlay() {
    this.overlayTarget.classList.add("hidden");
  }
}
